// import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Gist from 'react-gist';
import React from 'react';
// import ReactMarkdown from 'react-markdown/with-html';
import { withRouter } from 'react-router';
import Markdown from 'markdown-to-jsx';

// import * as actions from '../actions';
import BlogTitle from './BlogTitle';
// import MainContent from './MainContent';

// const imagesRenderer = () => {
// 	return <Gist id="7df0c9a5d794504a28bd3256b7bf5c4f" />;
// };

// const inlineCode = (props) => <Gist id={props.value} />;

// const source = '`7df0c9a5d794504a28bd3256b7bf5c4f` <p>asdasdasd</p><h1>title</h1>';
// <ReactMarkdown source={source} renderers={{ inlineCode }} escapeHtml={false} />

const renderGist = (props) => {
	return (
		<div className="blogGist">
			<Gist id={props.id} file={props.file} />
		</div>
	);
};

const BlogItem = ({ content, datePosted, history, image, meta, title }) => {
	return (
		<div className="col-12 text-left blogItem">
			<BlogTitle title={title} meta={meta} datePosted={datePosted} />
			<img src={`/images/blogs/${image}`} alt="Blog" className="blogHeaderImg" />
			<Markdown
				options={{
					overrides: {
						gist: {
							component: renderGist,
						},
					},
					// forceInline: true,
				}}
			>
				{content}
			</Markdown>
			<Button
				color="primary"
				variant="outlined"
				onClick={() => history.push(`/blogs`)}
				className="mt-5 mb-2"
				style={{ float: 'right' }}
			>
				Back to Blogs
			</Button>
		</div>
	);
};

// function mapStateToProps(state) {
// 	return {};
// }

// export default withRouter(
// 	connect(
// 		mapStateToProps,
// 		actions,
// 	)(BlogItem),
// );
export default withRouter(BlogItem);



// WEBPACK FOOTER //
// ./src/components/common/BlogItem.js